// 12 hours in ms — shifts midnight-UTC dates to noon-UTC to avoid
// date-boundary issues caused by timezone offsets during serialization.
export const NOON_UTC_OFFSET_MS = 43200000;

export const FIEIDS =[
    {
        "name": "customText11",
        "type": "SCALAR",
        "dataType": "String",
        "maxLength": 100,
        "confidential": false,
        "label": "Country of Passport or Citizenship",
        "options": [
            {
                "value": "Afghanistan",
                "label": "Afghanistan"
            },
            {
                "value": "Aland Islands",
                "label": "Aland Islands"
            },
            {
                "value": "Albania",
                "label": "Albania"
            },
            {
                "value": "Algeria",
                "label": "Algeria"
            },
            {
                "value": "American Samoa",
                "label": "American Samoa"
            },
            {
                "value": "Andorra",
                "label": "Andorra"
            },
            {
                "value": "Angola",
                "label": "Angola"
            },
            {
                "value": "Anguilla",
                "label": "Anguilla"
            },
            {
                "value": "Antarctica",
                "label": "Antarctica"
            },
            {
                "value": "Antigua and Barbuda",
                "label": "Antigua and Barbuda"
            },
            {
                "value": "Argentina",
                "label": "Argentina"
            },
            {
                "value": "Armenia",
                "label": "Armenia"
            },
            {
                "value": "Aruba",
                "label": "Aruba"
            },
            {
                "value": "Australia",
                "label": "Australia"
            },
            {
                "value": "Austria",
                "label": "Austria"
            },
            {
                "value": "Azerbaijan",
                "label": "Azerbaijan"
            },
            {
                "value": "Bahamas (the)",
                "label": "Bahamas (the)"
            },
            {
                "value": "Bahrain",
                "label": "Bahrain"
            },
            {
                "value": "Bangladesh",
                "label": "Bangladesh"
            },
            {
                "value": "Barbados",
                "label": "Barbados"
            },
            {
                "value": "Belarus",
                "label": "Belarus"
            },
            {
                "value": "Belgium",
                "label": "Belgium"
            },
            {
                "value": "Belize",
                "label": "Belize"
            },
            {
                "value": "Benin",
                "label": "Benin"
            },
            {
                "value": "Bermuda",
                "label": "Bermuda"
            },
            {
                "value": "Bhutan",
                "label": "Bhutan"
            },
            {
                "value": "Bolivia (Plurinational State of)",
                "label": "Bolivia (Plurinational State of)"
            },
            {
                "value": "Bonaire Sint Eustatius and Saba",
                "label": "Bonaire Sint Eustatius and Saba"
            },
            {
                "value": "Bosnia and Herzegovina",
                "label": "Bosnia and Herzegovina"
            },
            {
                "value": "Botswana",
                "label": "Botswana"
            },
            {
                "value": "Bouvet Island",
                "label": "Bouvet Island"
            },
            {
                "value": "Brazil",
                "label": "Brazil"
            },
            {
                "value": "British Indian Ocean Territory (the)",
                "label": "British Indian Ocean Territory (the)"
            },
            {
                "value": "Brunei Darussalam",
                "label": "Brunei Darussalam"
            },
            {
                "value": "Bulgaria",
                "label": "Bulgaria"
            },
            {
                "value": "Burkina Faso",
                "label": "Burkina Faso"
            },
            {
                "value": "Burundi",
                "label": "Burundi"
            },
            {
                "value": "Cabo Verde",
                "label": "Cabo Verde"
            },
            {
                "value": "Cambodia",
                "label": "Cambodia"
            },
            {
                "value": "Cameroon",
                "label": "Cameroon"
            },
            {
                "value": "Canada",
                "label": "Canada"
            },
            {
                "value": "Cayman Islands (the)",
                "label": "Cayman Islands (the)"
            },
            {
                "value": "Central African Republic (the)",
                "label": "Central African Republic (the)"
            },
            {
                "value": "Chad",
                "label": "Chad"
            },
            {
                "value": "Chile",
                "label": "Chile"
            },
            {
                "value": "China",
                "label": "China"
            },
            {
                "value": "Christmas Island",
                "label": "Christmas Island"
            },
            {
                "value": "Cocos (Keeling) Islands (the)",
                "label": "Cocos (Keeling) Islands (the)"
            },
            {
                "value": "Colombia",
                "label": "Colombia"
            },
            {
                "value": "Comoros (the)",
                "label": "Comoros (the)"
            },
            {
                "value": "Congo (the Democratic Republic of the)",
                "label": "Congo (the Democratic Republic of the)"
            },
            {
                "value": "Congo (the)",
                "label": "Congo (the)"
            },
            {
                "value": "Cook Islands (the)",
                "label": "Cook Islands (the)"
            },
            {
                "value": "Costa Rica",
                "label": "Costa Rica"
            },
            {
                "value": "Cote d'Ivoire",
                "label": "Cote d'Ivoire"
            },
            {
                "value": "Croatia",
                "label": "Croatia"
            },
            {
                "value": "Cuba",
                "label": "Cuba"
            },
            {
                "value": "Curacao",
                "label": "Curacao"
            },
            {
                "value": "Cyprus",
                "label": "Cyprus"
            },
            {
                "value": "Czechia",
                "label": "Czechia"
            },
            {
                "value": "Denmark",
                "label": "Denmark"
            },
            {
                "value": "Djibouti",
                "label": "Djibouti"
            },
            {
                "value": "Dominica",
                "label": "Dominica"
            },
            {
                "value": "Dominican Republic (the)",
                "label": "Dominican Republic (the)"
            },
            {
                "value": "Ecuador",
                "label": "Ecuador"
            },
            {
                "value": "Egypt",
                "label": "Egypt"
            },
            {
                "value": "El Salvador",
                "label": "El Salvador"
            },
            {
                "value": "Equatorial Guinea",
                "label": "Equatorial Guinea"
            },
            {
                "value": "Eritrea",
                "label": "Eritrea"
            },
            {
                "value": "Estonia",
                "label": "Estonia"
            },
            {
                "value": "Eswatini",
                "label": "Eswatini"
            },
            {
                "value": "Ethiopia",
                "label": "Ethiopia"
            },
            {
                "value": "Falkland Islands (the) [Malvinas]",
                "label": "Falkland Islands (the) [Malvinas]"
            },
            {
                "value": "Faroe Islands (the)",
                "label": "Faroe Islands (the)"
            },
            {
                "value": "Fiji",
                "label": "Fiji"
            },
            {
                "value": "Finland",
                "label": "Finland"
            },
            {
                "value": "France",
                "label": "France"
            },
            {
                "value": "French Guiana",
                "label": "French Guiana"
            },
            {
                "value": "French Polynesia",
                "label": "French Polynesia"
            },
            {
                "value": "French Southern Territories (the)",
                "label": "French Southern Territories (the)"
            },
            {
                "value": "Gabon",
                "label": "Gabon"
            },
            {
                "value": "Gambia (the)",
                "label": "Gambia (the)"
            },
            {
                "value": "Georgia",
                "label": "Georgia"
            },
            {
                "value": "Germany",
                "label": "Germany"
            },
            {
                "value": "Ghana",
                "label": "Ghana"
            },
            {
                "value": "Gibraltar",
                "label": "Gibraltar"
            },
            {
                "value": "Greece",
                "label": "Greece"
            },
            {
                "value": "Greenland",
                "label": "Greenland"
            },
            {
                "value": "Grenada",
                "label": "Grenada"
            },
            {
                "value": "Guadeloupe",
                "label": "Guadeloupe"
            },
            {
                "value": "Guam",
                "label": "Guam"
            },
            {
                "value": "Guatemala",
                "label": "Guatemala"
            },
            {
                "value": "Guernsey",
                "label": "Guernsey"
            },
            {
                "value": "Guinea",
                "label": "Guinea"
            },
            {
                "value": "Guinea-Bissau",
                "label": "Guinea-Bissau"
            },
            {
                "value": "Guyana",
                "label": "Guyana"
            },
            {
                "value": "Haiti",
                "label": "Haiti"
            },
            {
                "value": "Heard Island and McDonald Islands",
                "label": "Heard Island and McDonald Islands"
            },
            {
                "value": "Holy See (the)",
                "label": "Holy See (the)"
            },
            {
                "value": "Honduras",
                "label": "Honduras"
            },
            {
                "value": "Hong Kong",
                "label": "Hong Kong"
            },
            {
                "value": "Hungary",
                "label": "Hungary"
            },
            {
                "value": "Iceland",
                "label": "Iceland"
            },
            {
                "value": "India",
                "label": "India"
            },
            {
                "value": "Indonesia",
                "label": "Indonesia"
            },
            {
                "value": "Iran (Islamic Republic of)",
                "label": "Iran (Islamic Republic of)"
            },
            {
                "value": "Iraq",
                "label": "Iraq"
            },
            {
                "value": "Ireland",
                "label": "Ireland"
            },
            {
                "value": "Isle of Man",
                "label": "Isle of Man"
            },
            {
                "value": "Israel",
                "label": "Israel"
            },
            {
                "value": "Italy",
                "label": "Italy"
            },
            {
                "value": "Jamaica",
                "label": "Jamaica"
            },
            {
                "value": "Japan",
                "label": "Japan"
            },
            {
                "value": "Jersey",
                "label": "Jersey"
            },
            {
                "value": "Jordan",
                "label": "Jordan"
            },
            {
                "value": "Kazakhstan",
                "label": "Kazakhstan"
            },
            {
                "value": "Kenya",
                "label": "Kenya"
            },
            {
                "value": "Kiribati",
                "label": "Kiribati"
            },
            {
                "value": "Korea (the Democratic People's Republic of)",
                "label": "Korea (the Democratic People's Republic of)"
            },
            {
                "value": "Korea (the Republic of)",
                "label": "Korea (the Republic of)"
            },
            {
                "value": "Kuwait",
                "label": "Kuwait"
            },
            {
                "value": "Kyrgyzstan",
                "label": "Kyrgyzstan"
            },
            {
                "value": "Lao People's Democratic Republic (the)",
                "label": "Lao People's Democratic Republic (the)"
            },
            {
                "value": "Latvia",
                "label": "Latvia"
            },
            {
                "value": "Lebanon",
                "label": "Lebanon"
            },
            {
                "value": "Lesotho",
                "label": "Lesotho"
            },
            {
                "value": "Liberia",
                "label": "Liberia"
            },
            {
                "value": "Libya",
                "label": "Libya"
            },
            {
                "value": "Liechtenstein",
                "label": "Liechtenstein"
            },
            {
                "value": "Lithuania",
                "label": "Lithuania"
            },
            {
                "value": "Luxembourg",
                "label": "Luxembourg"
            },
            {
                "value": "Macao",
                "label": "Macao"
            },
            {
                "value": "Madagascar",
                "label": "Madagascar"
            },
            {
                "value": "Malawi",
                "label": "Malawi"
            },
            {
                "value": "Malaysia",
                "label": "Malaysia"
            },
            {
                "value": "Maldives",
                "label": "Maldives"
            },
            {
                "value": "Mali",
                "label": "Mali"
            },
            {
                "value": "Malta",
                "label": "Malta"
            },
            {
                "value": "Marshall Islands (the)",
                "label": "Marshall Islands (the)"
            },
            {
                "value": "Martinique",
                "label": "Martinique"
            },
            {
                "value": "Mauritania",
                "label": "Mauritania"
            },
            {
                "value": "Mauritius",
                "label": "Mauritius"
            },
            {
                "value": "Mayotte",
                "label": "Mayotte"
            },
            {
                "value": "Mexico",
                "label": "Mexico"
            },
            {
                "value": "Micronesia (Federated States of)",
                "label": "Micronesia (Federated States of)"
            },
            {
                "value": "Moldova (the Republic of)",
                "label": "Moldova (the Republic of)"
            },
            {
                "value": "Monaco",
                "label": "Monaco"
            },
            {
                "value": "Mongolia",
                "label": "Mongolia"
            },
            {
                "value": "Montenegro",
                "label": "Montenegro"
            },
            {
                "value": "Montserrat",
                "label": "Montserrat"
            },
            {
                "value": "Morocco",
                "label": "Morocco"
            },
            {
                "value": "Mozambique",
                "label": "Mozambique"
            },
            {
                "value": "Myanmar",
                "label": "Myanmar"
            },
            {
                "value": "Namibia",
                "label": "Namibia"
            },
            {
                "value": "Nauru",
                "label": "Nauru"
            },
            {
                "value": "Nepal",
                "label": "Nepal"
            },
            {
                "value": "Netherlands (the)",
                "label": "Netherlands (the)"
            },
            {
                "value": "New Caledonia",
                "label": "New Caledonia"
            },
            {
                "value": "New Zealand",
                "label": "New Zealand"
            },
            {
                "value": "Nicaragua",
                "label": "Nicaragua"
            },
            {
                "value": "Niger (the)",
                "label": "Niger (the)"
            },
            {
                "value": "Nigeria",
                "label": "Nigeria"
            },
            {
                "value": "Niue",
                "label": "Niue"
            },
            {
                "value": "Norfolk Island",
                "label": "Norfolk Island"
            },
            {
                "value": "North Macedonia",
                "label": "North Macedonia"
            },
            {
                "value": "Northern Mariana Islands (the)",
                "label": "Northern Mariana Islands (the)"
            },
            {
                "value": "Norway",
                "label": "Norway"
            },
            {
                "value": "Oman",
                "label": "Oman"
            },
            {
                "value": "Pakistan",
                "label": "Pakistan"
            },
            {
                "value": "Palau",
                "label": "Palau"
            },
            {
                "value": "Palestine (State of)",
                "label": "Palestine (State of)"
            },
            {
                "value": "Panama",
                "label": "Panama"
            },
            {
                "value": "Papua New Guinea",
                "label": "Papua New Guinea"
            },
            {
                "value": "Paraguay",
                "label": "Paraguay"
            },
            {
                "value": "Peru",
                "label": "Peru"
            },
            {
                "value": "Philippines (the)",
                "label": "Philippines (the)"
            },
            {
                "value": "Pitcairn",
                "label": "Pitcairn"
            },
            {
                "value": "Poland",
                "label": "Poland"
            },
            {
                "value": "Portugal",
                "label": "Portugal"
            },
            {
                "value": "Puerto Rico",
                "label": "Puerto Rico"
            },
            {
                "value": "Qatar",
                "label": "Qatar"
            },
            {
                "value": "Reunion",
                "label": "Reunion"
            },
            {
                "value": "Romania",
                "label": "Romania"
            },
            {
                "value": "Russian Federation (the)",
                "label": "Russian Federation (the)"
            },
            {
                "value": "Rwanda",
                "label": "Rwanda"
            },
            {
                "value": "Saint Barthelemy",
                "label": "Saint Barthelemy"
            },
            {
                "value": "Saint Helena Ascension and Tristan da Cunha",
                "label": "Saint Helena Ascension and Tristan da Cunha"
            },
            {
                "value": "Saint Kitts and Nevis",
                "label": "Saint Kitts and Nevis"
            },
            {
                "value": "Saint Lucia",
                "label": "Saint Lucia"
            },
            {
                "value": "Saint Martin (French part)",
                "label": "Saint Martin (French part)"
            },
            {
                "value": "Saint Pierre and Miquelon",
                "label": "Saint Pierre and Miquelon"
            },
            {
                "value": "Saint Vincent and the Grenadines",
                "label": "Saint Vincent and the Grenadines"
            },
            {
                "value": "Samoa",
                "label": "Samoa"
            },
            {
                "value": "San Marino",
                "label": "San Marino"
            },
            {
                "value": "Sao Tome and Principe",
                "label": "Sao Tome and Principe"
            },
            {
                "value": "Saudi Arabia",
                "label": "Saudi Arabia"
            },
            {
                "value": "Senegal",
                "label": "Senegal"
            },
            {
                "value": "Serbia",
                "label": "Serbia"
            },
            {
                "value": "Seychelles",
                "label": "Seychelles"
            },
            {
                "value": "Sierra Leone",
                "label": "Sierra Leone"
            },
            {
                "value": "Singapore",
                "label": "Singapore"
            },
            {
                "value": "Sint Maarten (Dutch part)",
                "label": "Sint Maarten (Dutch part)"
            },
            {
                "value": "Slovakia",
                "label": "Slovakia"
            },
            {
                "value": "Slovenia",
                "label": "Slovenia"
            },
            {
                "value": "Solomon Islands",
                "label": "Solomon Islands"
            },
            {
                "value": "Somalia",
                "label": "Somalia"
            },
            {
                "value": "South Africa",
                "label": "South Africa"
            },
            {
                "value": "South Georgia and the South Sandwich Islands",
                "label": "South Georgia and the South Sandwich Islands"
            },
            {
                "value": "South Sudan",
                "label": "South Sudan"
            },
            {
                "value": "Spain",
                "label": "Spain"
            },
            {
                "value": "Sri Lanka",
                "label": "Sri Lanka"
            },
            {
                "value": "Sudan (the)",
                "label": "Sudan (the)"
            },
            {
                "value": "Suriname",
                "label": "Suriname"
            },
            {
                "value": "Svalbard and Jan Mayen",
                "label": "Svalbard and Jan Mayen"
            },
            {
                "value": "Sweden",
                "label": "Sweden"
            },
            {
                "value": "Switzerland",
                "label": "Switzerland"
            },
            {
                "value": "Syrian Arab Republic (the)",
                "label": "Syrian Arab Republic (the)"
            },
            {
                "value": "Taiwan",
                "label": "Taiwan"
            },
            {
                "value": "Tajikistan",
                "label": "Tajikistan"
            },
            {
                "value": "Tanzania (the United Republic of)",
                "label": "Tanzania (the United Republic of)"
            },
            {
                "value": "Thailand",
                "label": "Thailand"
            },
            {
                "value": "Timor-Leste",
                "label": "Timor-Leste"
            },
            {
                "value": "Togo",
                "label": "Togo"
            },
            {
                "value": "Tokelau",
                "label": "Tokelau"
            },
            {
                "value": "Tonga",
                "label": "Tonga"
            },
            {
                "value": "Trinidad and Tobago",
                "label": "Trinidad and Tobago"
            },
            {
                "value": "Tunisia",
                "label": "Tunisia"
            },
            {
                "value": "Turkey",
                "label": "Turkey"
            },
            {
                "value": "Turkmenistan",
                "label": "Turkmenistan"
            },
            {
                "value": "Turks and Caicos Islands (the)",
                "label": "Turks and Caicos Islands (the)"
            },
            {
                "value": "Tuvalu",
                "label": "Tuvalu"
            },
            {
                "value": "Uganda",
                "label": "Uganda"
            },
            {
                "value": "Ukraine",
                "label": "Ukraine"
            },
            {
                "value": "United Arab Emirates (the)",
                "label": "United Arab Emirates (the)"
            },
            {
                "value": "United Kingdom of Great Britain and Northern Ireland (the)",
                "label": "United Kingdom of Great Britain and Northern Ireland (the)"
            },
            {
                "value": "United States Minor Outlying Islands (the)",
                "label": "United States Minor Outlying Islands (the)"
            },
            {
                "value": "United States of America (the)",
                "label": "United States of America (the)"
            },
            {
                "value": "Uruguay",
                "label": "Uruguay"
            },
            {
                "value": "Uzbekistan",
                "label": "Uzbekistan"
            },
            {
                "value": "Vanuatu",
                "label": "Vanuatu"
            },
            {
                "value": "Venezuela (Bolivarian Republic of)",
                "label": "Venezuela (Bolivarian Republic of)"
            },
            {
                "value": "Viet Nam",
                "label": "Viet Nam"
            },
            {
                "value": "Virgin Islands (British)",
                "label": "Virgin Islands (British)"
            },
            {
                "value": "Virgin Islands (U.S.)",
                "label": "Virgin Islands (U.S.)"
            },
            {
                "value": "Wallis and Futuna",
                "label": "Wallis and Futuna"
            },
            {
                "value": "Western Sahara",
                "label": "Western Sahara"
            },
            {
                "value": "Yemen",
                "label": "Yemen"
            },
            {
                "value": "Zambia",
                "label": "Zambia"
            },
            {
                "value": "Zimbabwe",
                "label": "Zimbabwe"
            }
        ],
        "hideFromSearch": false
    },
    {
        "name": "customText13",
        "type": "SCALAR",
        "dataType": "String",
        "maxLength": 100,
        "confidential": false,
        "label": "First Language",
        "options": [
            {
                "value": "English",
                "label": "English"
            },
            {
                "value": "Mandarin",
                "label": "Mandarin"
            },
            {
                "value": "Akan",
                "label": "Akan"
            },
            {
                "value": "Amharic",
                "label": "Amharic"
            },
            {
                "value": "Arabic",
                "label": "Arabic"
            },
            {
                "value": "Assamese",
                "label": "Assamese"
            },
            {
                "value": "Awadhi",
                "label": "Awadhi"
            },
            {
                "value": "Azerbaijani",
                "label": "Azerbaijani"
            },
            {
                "value": "Balochi",
                "label": "Balochi"
            },
            {
                "value": "Belarusian",
                "label": "Belarusian"
            },
            {
                "value": "Bengali",
                "label": "Bengali"
            },
            {
                "value": "Bhojpuri",
                "label": "Bhojpuri"
            },
            {
                "value": "Bislamah",
                "label": "Bislamah"
            },
            {
                "value": "Burmese",
                "label": "Burmese"
            },
            {
                "value": "Cebuano (Visayan)",
                "label": "Cebuano (Visayan)"
            },
            {
                "value": "Chewa",
                "label": "Chewa"
            },
            {
                "value": "Chhattisgarhi",
                "label": "Chhattisgarhi"
            },
            {
                "value": "Chittagonian",
                "label": "Chittagonian"
            },
            {
                "value": "Czech",
                "label": "Czech"
            },
            {
                "value": "Deccan",
                "label": "Deccan"
            },
            {
                "value": "Dhundhari",
                "label": "Dhundhari"
            },
            {
                "value": "Dutch",
                "label": "Dutch"
            },
            {
                "value": "Eastern Min",
                "label": "Eastern Min"
            },
            {
                "value": "English",
                "label": "English"
            },
            {
                "value": "Estonian",
                "label": "Estonian"
            },
            {
                "value": "French",
                "label": "French"
            },
            {
                "value": "Fula",
                "label": "Fula"
            },
            {
                "value": "Gan Chinese",
                "label": "Gan Chinese"
            },
            {
                "value": "German",
                "label": "German"
            },
            {
                "value": "Greek",
                "label": "Greek"
            },
            {
                "value": "Gujarati",
                "label": "Gujarati"
            },
            {
                "value": "Haitian Creole",
                "label": "Haitian Creole"
            },
            {
                "value": "Hakka",
                "label": "Hakka"
            },
            {
                "value": "Haryanvi",
                "label": "Haryanvi"
            },
            {
                "value": "Hausa",
                "label": "Hausa"
            },
            {
                "value": "Hiligaynon (Visayan)",
                "label": "Hiligaynon (Visayan)"
            },
            {
                "value": "Hebrew",
                "label": "Hebrew"
            },
            {
                "value": "Hindi",
                "label": "Hindi"
            },
            {
                "value": "Hmong",
                "label": "Hmong"
            },
            {
                "value": "Hungarian",
                "label": "Hungarian"
            },
            {
                "value": "Igbo",
                "label": "Igbo"
            },
            {
                "value": "Ilocano",
                "label": "Ilocano"
            },
            {
                "value": "Italian",
                "label": "Italian"
            },
            {
                "value": "Japanese",
                "label": "Japanese"
            },
            {
                "value": "Javanese",
                "label": "Javanese"
            },
            {
                "value": "Jin",
                "label": "Jin"
            },
            {
                "value": "Kannada",
                "label": "Kannada"
            },
            {
                "value": "Kazakh",
                "label": "Kazakh"
            },
            {
                "value": "Khmer",
                "label": "Khmer"
            },
            {
                "value": "Kinyarwanda",
                "label": "Kinyarwanda"
            },
            {
                "value": "Kirundi",
                "label": "Kirundi"
            },
            {
                "value": "Konkani",
                "label": "Konkani"
            },
            {
                "value": "Korean",
                "label": "Korean"
            },
            {
                "value": "Kurdish",
                "label": "Kurdish"
            },
            {
                "value": "Madurese",
                "label": "Madurese"
            },
            {
                "value": "Magahi",
                "label": "Magahi"
            },
            {
                "value": "Maithili",
                "label": "Maithili"
            },
            {
                "value": "Malagasy",
                "label": "Malagasy"
            },
            {
                "value": "Malayalam",
                "label": "Malayalam"
            },
            {
                "value": "Malaysian/Indonesian",
                "label": "Malaysian/Indonesian"
            },
            {
                "value": "Mandarin",
                "label": "Mandarin"
            },
            {
                "value": "Marathi",
                "label": "Marathi"
            },
            {
                "value": "Marwari",
                "label": "Marwari"
            },
            {
                "value": "Mossi",
                "label": "Mossi"
            },
            {
                "value": "Nepali",
                "label": "Nepali"
            },
            {
                "value": "Northern Min",
                "label": "Northern Min"
            },
            {
                "value": "Odia (Oriya)",
                "label": "Odia (Oriya)"
            },
            {
                "value": "Oromo",
                "label": "Oromo"
            },
            {
                "value": "Pashto",
                "label": "Pashto"
            },
            {
                "value": "Persian",
                "label": "Persian"
            },
            {
                "value": "Pigeon",
                "label": "Pigeon"
            },
            {
                "value": "Polish",
                "label": "Polish"
            },
            {
                "value": "Portuguese",
                "label": "Portuguese"
            },
            {
                "value": "Punjabi",
                "label": "Punjabi"
            },
            {
                "value": "Quechua",
                "label": "Quechua"
            },
            {
                "value": "Romanian",
                "label": "Romanian"
            },
            {
                "value": "Russian",
                "label": "Russian"
            },
            {
                "value": "Saraiki",
                "label": "Saraiki"
            },
            {
                "value": "Serbo-Croatian",
                "label": "Serbo-Croatian"
            },
            {
                "value": "Shona",
                "label": "Shona"
            },
            {
                "value": "Sindhi",
                "label": "Sindhi"
            },
            {
                "value": "Sinhalese",
                "label": "Sinhalese"
            },
            {
                "value": "Somali",
                "label": "Somali"
            },
            {
                "value": "Southern Min",
                "label": "Southern Min"
            },
            {
                "value": "Spanish",
                "label": "Spanish"
            },
            {
                "value": "Sundanese",
                "label": "Sundanese"
            },
            {
                "value": "Swedish",
                "label": "Swedish"
            },
            {
                "value": "Sylheti",
                "label": "Sylheti"
            },
            {
                "value": "Tagalog/Filipino",
                "label": "Tagalog/Filipino"
            },
            {
                "value": "Tamil",
                "label": "Tamil"
            },
            {
                "value": "Telugu",
                "label": "Telugu"
            },
            {
                "value": "Thai (excl. Lao)",
                "label": "Thai (excl. Lao)"
            },
            {
                "value": "Turkish",
                "label": "Turkish"
            },
            {
                "value": "Turkmen",
                "label": "Turkmen"
            },
            {
                "value": "Ukrainian",
                "label": "Ukrainian"
            },
            {
                "value": "Urdu",
                "label": "Urdu"
            },
            {
                "value": "Uyghur",
                "label": "Uyghur"
            },
            {
                "value": "Uzbek",
                "label": "Uzbek"
            },
            {
                "value": "Vietnamese",
                "label": "Vietnamese"
            },
            {
                "value": "Wu (inc. Shanghainese)",
                "label": "Wu (inc. Shanghainese)"
            },
            {
                "value": "Xhosa",
                "label": "Xhosa"
            },
            {
                "value": "Xiang (Hunnanese)",
                "label": "Xiang (Hunnanese)"
            },
            {
                "value": "Yoruba",
                "label": "Yoruba"
            },
            {
                "value": "Yue (incl. Cantonese)",
                "label": "Yue (incl. Cantonese)"
            },
            {
                "value": "Zhuang",
                "label": "Zhuang"
            },
            {
                "value": "Zulu",
                "label": "Zulu"
            }
        ],
        "hideFromSearch": false
    },
    {
        "name": "gender",
        "type": "SCALAR",
        "dataType": "String",
        "maxLength": 1,
        "confidential": false,
        "label": "Gender",
        "options": [
            {
                "value": "M",
                "label": "Male"
            },
            {
                "value": "F",
                "label": "Female"
            },
            {
                "value": "X",
                "label": "X (indeterminate/intersex/unspecified)"
            }
        ],
        "hideFromSearch": false
    },
    {
        "name": "namePrefix",
        "type": "SCALAR",
        "dataType": "String",
        "maxLength": 20,
        "confidential": false,
        "label": "Title",
        "options": [
            {
                "value": "Miss",
                "label": "Miss"
            },
            {
                "value": "Mr.",
                "label": "Mr."
            },
            {
                "value": "Mrs.",
                "label": "Mrs."
            },
            {
                "value": "Ms.",
                "label": "Ms."
            }
        ],
        "hideFromSearch": false
    }
]
export const embedUrl:string= 'https://app.powerbi.com/reportEmbed?reportId=9ad55a71-204e-4c2e-aee0-f8a622eca196&autoAuth=true&ctid=8cb6eb4c-d35a-4da1-8ef5-3230109990f7'

export  const states =[
"Australian Capital Territory",
"New South Wales",
"Northern Territory",
"Queensland",
"South Australia",
"Tasmania",
"Victoria",
"Western Australia"
] 